<template>
    <div class="mt-5 form-material">
        <h3>Image Update</h3>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label for="serviceId">Service</label>
                    <input type="text" class="form-control" id="serviceId" v-model="serviceId">
                </div>
                <button @click="updateImageService" :disabled="uploading">Update</button>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="hotelId">Hotel</label>
                    <input type="text" class="form-control" id="hotelId" v-model="hotelId">
                </div>
                <button @click="updateImageHotel" :disabled="uploading">Update</button>
            </div>
        </div>
    </div>
  </template>
  
  <script>
  const api = window.api;
  
  export default {
    name: "ImageUpdate",
    data() {
      return {
        serviceId: null,
        hotelId: null,
        uploading: false,
      };
    },
    mounted() {
    },
    methods: {
      async updateImageService() {
        this.uploading = true;
        let res = await api.post("/api/tpsql/sync_images_service/", JSON.stringify({serviceId: this.serviceId}), {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }, (err) => { 
          this.$root.$refs.index.showNotification(err, 'danger')
          this.uploading = false;
        });
        if (res) {
          alert("Image updated");
          this.uploading = false;
        }
      },
      async updateImageHotel() {
        this.uploading = true;
        let res = await api.post("/api/tpsql/sync_images_hotel/", JSON.stringify({hotelId: this.hotelId}), {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }, (err) => { 
          this.$root.$refs.index.showNotification(err, 'danger')
          this.uploading = false;
        });
        if (res) {
          alert("Image updated");
          this.uploading = false;
        }
      },
    },
  };
  </script>
  
